<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

// body::-webkit-scrollbar {
//   dispay: none;
// }
// ::-webkit-scrollbar {
//     display: none;
// }

/* 垂直滚动条样式 */
/* 宽度 */
::-webkit-scrollbar {
  width: 12px;
}

/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}

/* 水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 12px;
}

/* 背景色 */
::-webkit-scrollbar-track {
  background: hsla(0, 0%, 37%, 0.1);
  border-radius: 10px;
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 100%, 0.1);
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  border-radius: 10px;
  background: hsla(0, 0%, 100%, 0.1);
}

#app {
  width: 100%;
  height: 100%;
}
//排名
.user-name {
  color: #fff;
}
.score {
  color: #fff;
}

// 选手
.player-card {
  min-width: 8vw;
  margin-bottom: 40px;
  padding: 5px;
  background-color: #d4a756;
  border-radius: 5px;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3);
  color: #fff;
  width: 140px;
  .avatar {
    width: 100%;
    height: calc(100% - 60px);

    .el-image {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }

  .player-info {
    font-size: 15px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    .marks {
      font-size: 20px;
      color: #ff0000;
    }
  }

  &.hidden {
    opacity: 0;
  }
}
// 选手
.player-card1 {
  min-width: 8vw;
  margin-bottom: 40px;
  padding: 5px;
  // background-color: #d4a756;
  // border-radius: 5px;
  // box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3);
  color: #fff;
  width: 140px;
  .avatar {
    width: 100%;
    height: calc(100% - 60px);

    .el-image {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }

  .player-info {
    height: 60px;
    font-size: 15px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    .marks {
      font-size: 20px;
      color: #ffffff;
    }
  }

  &.hidden {
    opacity: 0;
  }
}
.zam-app-flex-ajCenter {
  /**flex布局 + 水平垂直并且子元素竖排居中**/
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.zam-app-flex-ajCenter2 {
  /**flex布局 + 水平垂直居中**/
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.zam-app-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.zam-app-flex-alignflexend {
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.zam-app-justifyCenter {
  /**flex布局 垂直居中**/
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.zam-app-directionColumn {
  /**flex布局 子元素垂直排列**/
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.zam-app-alignCenter {
  /**flex布局 水平居中**/
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.zam-app-directionColumn {
  /**flex布局 子元素垂直排列**/
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
</style>
